module.exports = __webpack_public_path__ + "img/alfred_logo.9fcf83e2.png";